<template>
  <v-tooltip
    v-model="tooltip"
    top
  >
    <template #activator="{ on }">
      <v-text-field
        :value="value"
        v-bind="$attrs"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :counter="true"
        name="password"
        :type="! showPassword ? 'password' : 'text'"
        @input="val => $emit('input', val)"
        @change="val => $emit('change', val)"
        @click:append="() => (showPassword = !showPassword)"
        @focus="tooltip = true"
        @blur="tooltip = false"
      />
    </template>
    <div>
      <b>{{ $t('The password must contain at least:') }}</b><br>
      <ul>
        <li>{{ $t('8 characters') }}</li>
      </ul>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  props: {
      value: {
        type: [String, Object, Number],
        required: false,
        default: null
      },
  },

  data() {
    return {
      tooltip: false,
      showPassword: false,
    }
  }
}
</script>